<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    strokeColor: {
      type: String,
    },
    strokeWidth: {
      type: Number,
      default: 0,
    },
  },
})
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="13"
    viewBox="0 0 17 13"
    fill="none"
  >
    <path
      d="M14.9759 0.31053C15.3492 -0.0892872 15.9701 -0.105179 16.3622 0.275374C16.7542 0.656152 16.7698 1.28949 16.3967 1.68944L6.59277 12.1895C6.40773 12.3876 6.15068 12.5 5.88237 12.5C5.61406 12.5 5.35701 12.3876 5.17197 12.1895L0.270013 6.93945L0.204909 6.8623C-0.0997658 6.46182 -0.0631355 5.88249 0.30448 5.52538C0.672044 5.16865 1.23991 5.16057 1.61709 5.49023L1.69081 5.56054L5.88237 10.0488L14.9759 0.31053Z"
      fill="currentColor"
      :stroke="strokeColor"
      :stroke-width="strokeWidth"
    />
  </svg>
</template>
